import { type PropsWithChildren } from "react";

import styles from "./mobile-menu.module.scss";

type MobileMenuProps = PropsWithChildren<{
  onClose: () => void;
  align?: "right" | "left";
}>;

export const MobileMenu = ({
  onClose,
  align = "left",
  children,
}: MobileMenuProps) => {
  return (
    <div className={styles.wrapper}>
      <button
        className={styles.overlay}
        onClick={onClose}
        aria-label="Close menu"
      />
      <div
        className={`${styles.content} ${align === "right" ? styles.right : ""}`}
      >
        {children}
      </div>
    </div>
  );
};
